import React, { useState, useEffect } from 'react';
import { Paper, Stack, Button, Box } from '@mui/material';
import { Helmet } from 'react-helmet';

const SESSION_URL_KEY = 'url';
const LEGACY_URL_PATTERNS = [
  'script.google.com/a/macros/lideresenmovimiento.mx/s/AKfycbxPy3TJyUlptbn04ImDDeIfW11BDdbmhZ3Iz68nO3XgFt_yhakCSACdsTLZPwExXF7W/exec',
];

const isLegacyUrl = (value) => {
  if (!value) return false;

  return LEGACY_URL_PATTERNS.some((pattern) => value.includes(pattern));
};

const Perfiles = () => {
  const [password, setPassword] = useState('');
  const [url, setUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // If the url is in the session then add it
  useEffect(() => {
    const sessionUrl = sessionStorage.getItem(SESSION_URL_KEY);
    if (sessionUrl) {
      if (isLegacyUrl(sessionUrl)) {
        sessionStorage.removeItem(SESSION_URL_KEY);
        return;
      }

      setUrl(sessionUrl);
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    fetch('https://mw2j4v9orh.execute-api.us-east-2.amazonaws.com/v1/perfiles', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ password }),
    })
      .then((response) => {
        if (response.ok) {
          response.json().then((data) => {
            setUrl(data.url);
            sessionStorage.setItem(SESSION_URL_KEY, data.url);
          });
        } else {
          setError('Contraseña incorrecta');
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error:', error);
        setError('Error al verificar la contraseña');
        setLoading(false);
      });
  };

  if (url) {
    return (
      <div style={{ width: '100%', height: '100vh' }}>
        <iframe
          src={url}
          title="Contenido protegido"
          style={{ width: '100%', height: '100%', border: 'none' }}
        />
      </div>
    );
  }

  return (
    <Stack
      sx={{
        flexGrow: 1,
        width: '100%',
        height: '100%',
        background: 'linear-gradient(90deg, #008fa9, #17af83, #6ccf48)',
        justifyContent: 'center',
      }}
    >
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Box sx={{ typography: 'h4', fontWeight: 'bold', color: 'white', mb: 4 }}>
        Egresados Perfiles Profesionales
      </Box>
      <Stack sx={{ alignItems: 'center', justifyContent: 'center' }}>
        <Paper elevation={3} sx={{ padding: 4, borderRadius: 4 }}>
          <h2>Ingresa la contraseña</h2>
          <form onSubmit={handleSubmit}>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Contraseña"
              style={{ padding: 8, marginBottom: 10 }}
            />
            <br />
            <Button type="submit" variant="contained" style={{ padding: '8px 16px' }}>
              Acceder
            </Button>
          </form>
          {error && <div style={{ color: 'red', marginTop: 10 }}>{error}</div>}
        </Paper>
      </Stack>
    </Stack>
  );
};

export default Perfiles;
